import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SellerManageComponent } from './seller-manage/seller-manage.component';


export const sellerRoutes: Routes = [
  {
    path: 'seller',
    data: {
      'expectedRoles': ['Admin','IT']
    },
    children: [
      {
        path: 'manage',
        component: SellerManageComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(sellerRoutes)],
  exports: [RouterModule]
})
export class SellerRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller-routing.module.ts